/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicBudgetAlert extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicBudgetAlert");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicBudgetAlert.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicBudgetAlert>): BackgroundJobPayloadForPeriodicBudgetAlert {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicBudgetAlert(), model);
        BackgroundJobPayloadForPeriodicBudgetAlert.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicBudgetAlert>): BackgroundJobPayloadForPeriodicBudgetAlert {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicBudgetAlert.newInstance(<BackgroundJobPayloadForPeriodicBudgetAlert> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicBudgetAlert) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicBudgetAlert.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicBudgetAlert): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicBudgetAlert.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
